import type { CloudEnvironment } from './CloudEnvironment';

export interface AppManifestV1 {
  appType: AppType;
  artifacts: AppArtifact[];
  bucketName: string;
  buildInfo: AppBuildInfo;
  manifestVersion: number;
  packageName: string;
  uploadedAtUtc: string;
  version: string;
}

export interface AppBuildInfo {
  buildHash: string;
  buildTimestamp: string;
  electronVersion?: string;
  nodeVersion?: string;
}

export interface AppArtifact {
  artifactType: AppArtifactType;
  bucketKey: string;
  md5Hash: string;
  name: string;
  platform?: AppPlatform;
  s3VersionId?: string;
  sizeBytes: number;
}

export enum AppType {
  ELECTRON = 'ELECTRON',
  SPA = 'SPA'
}

export enum AppPlatform {
  DARWIN_ARM64 = 'darwin-arm64',
  DARWIN_X64 = 'darwin-x64',
  LINUX_X64 = 'linux-x64',
  WIN32_X64 = 'win32-x64'
}

export enum AppArtifactType {
  DEB = 'deb',
  DMG = 'dmg',
  EXE = 'exe',
  RPM = 'rpm',
  SPA_BUNDLE = 'spa-bundle',
  ZIP = 'zip'
}

/**
 * Build mode indicates how the app is running.
 * - HMR: Running with Hot Module Replacement on localhost or dev server
 * - COMPILED: Compiled production build
 */
export enum AppMode {
  COMPILED = 'compiled',
  HMR = 'hmr'
}

/**
 * Deployment environment indicates which environment the app is connected to.
 * This value comes from config.json at runtime.
 */
export type AppEnvironment = CloudEnvironment | 'localhost';
